import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import Experience from "./Experience";
import laptopImg from "../../Assets/sanjeet.png";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px", color: "white" }}>
              About <strong className="purple">Sanjeet</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img blob-container"
          >
            <div className="blob">
              <img src={laptopImg} alt="about" className="img-fluid" style={{ maxHeight: "450px", width: "100%", height: "100%", objectFit: "contain" }} />
            </div>
          </Col>
        </Row>
        <Experience />

        <h1 className="project-heading" style={{ marginTop: "50px", color: "white" }}>
          Professional <strong className="purple">Skillset </strong>
        </h1>

        <Techstack />
      </Container>
    </Container>
  );
}

export default About;
